export default __webpack_public_path__ + "java.571c0b1e.png";